export default __webpack_public_path__ + "static/google-cloud-f8e73fc721043e3c8e27f411aac2e386.png";